import Override from "./Override";

export default Override;
